/**
 * Client documents (CLIENT_DOCUMENTS_PLAN.md): branded documents the CRM makes (an agreement, a letter, a
 * report) and sends to a client's account. The client reads them in My Account → Documents and, when the
 * document asks for it, signs there: being signed in is the identity check. The CRM renders every PDF;
 * Platform keeps the original and the final signed copy, records the signature and reports back.
 */
export const CLIENT_DOCUMENT_KINDS = ['agreement', 'letter', 'report'];
/**
 * The only HTML a document may contain, with no attributes at all: the API keeps these tags and the text
 * of everything else, and the web app renders the same list into React elements.
 */
export const DOCUMENT_HTML_TAGS = [
    'p', 'h1', 'h2', 'h3', 'strong', 'b', 'em', 'i', 'u', 's', 'ul', 'ol', 'li',
    'table', 'thead', 'tbody', 'tr', 'th', 'td', 'blockquote', 'hr', 'br', 'span',
];
/** Elements whose content is never text for the reader: dropped with everything inside them. */
export const DOCUMENT_HTML_DROP = [
    'script', 'style', 'template', 'iframe', 'object', 'embed', 'noscript', 'textarea', 'title', 'head',
    'svg', 'math', 'select', 'xmp', 'noembed', 'noframes', 'plaintext',
];
/** What the client agrees to by ticking the box; recorded with the signature and sent to the CRM. */
export const DOCUMENT_CONSENT_TEXT = 'I have read this document and I agree to sign it electronically.';
/** Limits (the CRM's commands and the client's signature). */
export const DOCUMENT_LIMITS = {
    referenceMax: 40,
    titleMax: 160,
    htmlMaxBytes: 200 * 1024,
    pdfMaxBytes: 8 * 1024 * 1024,
    messageMax: 1000,
    agentNameMax: 80,
    logoMaxBytes: 256 * 1024,
    signerNameMin: 2,
    signerNameMax: 80,
    signatureImageMaxBytes: 300 * 1024,
    declineReasonMax: 500,
};
/** True while the client can still sign it. */
export const documentSignable = (d, now = Date.now()) => d.requiresSignature && (d.status === 'sent' || d.status === 'viewed') && (!d.expiresAt || Date.parse(d.expiresAt) > now);
//# sourceMappingURL=client-documents.js.map